export function SubBasinsIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path d="M8 3 3 8v8l5 5h8l5-5V8l-5-5H8Z" strokeLinejoin="round" />
    </svg>
  );
}

export function ZonesIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <circle cx="9" cy="10" r="5" />
      <circle cx="16" cy="14" r="5" />
    </svg>
  );
}

export function WaterIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path d="M12 3c4 5 7 8.5 7 12a7 7 0 1 1-14 0c0-3.5 3-7 7-12Z" strokeLinejoin="round" />
    </svg>
  );
}

export function AquiferIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path d="M3 8h18M3 13h18M3 18h18" strokeLinecap="round" />
    </svg>
  );
}

export function LayersIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path d="M12 3 2 8l10 5 10-5-10-5Z" strokeLinejoin="round" />
      <path d="m2 13 10 5 10-5" strokeLinejoin="round" />
    </svg>
  );
}

export function SeriesIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path d="M3 17l5-6 4 4 9-10" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
